<template>
  <div class="head-page">
    <Header :title="$t('lockming.tolockming')" />
    <div class="head-page-overflow" style="padding-bottom: 50px">
      <div class="loan-area">
        <div class="title-box">
          <div class="icon"><img src="../../assets//logod.png" /></div>
          <div class="title">{{ itemdata.title }}</div>
        </div>
      </div>
      <div class="loan-area">
        <p class="desc">
          {{ $t("lockming.days") }} : {{ itemdata.cycle }} {{ $t("common.day") }}
        </p>
        <p class="desc">
          {{ $t("lockming.locknum") }} : {{ itemdata.min_price }} - {{ itemdata.max_price }}
        </p>
      </div>
      <div class="loan-area">
        <van-cell :title="$t('lockming.getforday')">
          <template #default>  {{ itemdata.interest_rate }} % </template>
        </van-cell>
        <van-cell :title="$t('lockming.estimation')">
          <template #default>
            {{ parseFloat(lixi).toFixed(8) }} {{ itemdata.coin_title }}
          </template>
        </van-cell>
        <van-cell :title="$t('lockming.balance')">
          <template #default>
            {{ parseFloat(balance).toFixed(8) }} {{ itemdata.coin_title }}
          </template>
        </van-cell>
        <van-cell :title="$t('lockming.nums')">
          <template #default>
            <van-stepper
            @change="amountChange"
              v-model="frm.amount"
              :min="itemdata.min_price"
              :max="itemdata.max_price"
              theme="round"
              integer
              input-width="80px"
              button-size="32px"
            />
          </template>
        </van-cell>
      </div>
    </div>
    <LoanFoot
      :money="frm.amount"
      :posting="posting"
      :btnName="$t('lockming.tolockming')"
      @page-submit="toSub"
    />
  </div>
</template>
  
  <script>
import Header from "@/components/Header";
import LoanFoot from "./components/footer.vue";
export default {
  name: "LockmingApplication",
  components: { Header, LoanFoot },
  data() {
    return {
      itemdata: {},
      money: 100,
      id: null,
      balance: 0,
      lixi: 0,
      posting:false,
      frm: {
        id: null, //	是	int	贷款项目id
        amount: null, //	是	int	申请金额
      },
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.getData();
    }
  },
  methods: {
    toSub() {
      this.toSubmit();
    },
    async toSubmit() {
      if (
        this.frm.amount < this.itemdata.minprice ||
        this.frm.amount > this.itemdata.maxprice
      ) {
        this.$toast.fail(
          this.$t("loans.Expected_loan_amounterror", {
            min: this.itemdata.minprice,
            max: this.itemdata.maxprice,
          })
        );
        return;
      }
      if (this.posting) {
        return;
      }
      this.posting = true;
      await this.$http({
        method: "post",
        url: "buyMiningMachine",
        data: this.frm,
      })
        .then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
          this.frm.amount = this.itemdata.min_price;
          this.amountChange(this.frm.amount)
        })
        .catch(() => {
          this.posting = false;
        });
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getMiningMachineList",
        data: { id: this.id },
      }).then((res) => {
        this.itemdata = res.data.list[0];
        if (this.itemdata) {
          this.frm.amount = this.itemdata.min_price;
          this.amountChange(this.frm.amount)
          this.frm.id = this.itemdata.id;
          this.getBalance()
        }
      });
    },
    async getBalance(){
      await this.$http({
        method: "post",
        url: "getCoinBalance",
        data: { c_id: this.itemdata.c_id },
      }).then((res) => {
        res.data.balance_list.forEach(element => {
          if(element.type == 1)this.balance = element.balance
        });
      });
    },
    amountChange(val){
      this.lixi = parseFloat(val) * parseFloat(this.itemdata.interest_rate) * parseFloat(this.itemdata.cycle) / 100
    }
  },
};
</script>
  
  <style>
</style>
  